import * as yup from "yup";

export const createContactsValidationSchema = () => {
  const registrationValidationSchema = yup.object({
    email: yup.string().email(),
  });

  return registrationValidationSchema;
};
